export default __webpack_public_path__ + "ee946bbea99ab650efbdbe9c89355b25.png";